/*
 *  -----------------------------------------------------------------------
 *    <copyright file="study-cm-setup.helper.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { StudyFields } from '@queries/generated/fragments.generated';

export const boolToYesNo = (value: boolean | string | null) => (value ? 'yes' : 'no');

export const getStudySummaryDisplay = (study: StudyFields, translate: (value: string) => string) => {
    const itemsToDisplay: string[] = [];

    if (study.displayRiskOverviewOnStudySummary) {
        itemsToDisplay.push(translate('admin:riskOverview'));
    }
    if (study.displayStudySiteOverviewOnStudySummary) {
        itemsToDisplay.push(translate('admin:siteOverview'));
    }
    if (
        study.displayStudyOverviewOnStudySummary &&
        study.studyOverviewTableConfiguration?.columnConfigurations?.length
    ) {
        itemsToDisplay.push(translate('admin:studyOverview'));
    }

    return itemsToDisplay.join(', ');
};
